/**
 * DeviceDetection const symbols.
 * @constant
 * @type {Object}
 */



const DEVICE_DETECTION = {
    KEY_IS_EMULATOR: 'IsEmulator',
    KEY_IS_ROOT_1: 'IsRootMethod1',
    KEY_IS_ROOT_2: 'IsRootMethod2',
    KEY_IS_ROOT_3: 'IsRootMethod3',
    KEY_IS_JAIL_BROKEN: 'IsJailBroken'

};

export {DEVICE_DETECTION};